import React from 'react';
import { Button } from 'antd';
import { HubType } from '../graphql/queries/getHubList';
import SingleSelect from 'components/SingleSelect';
import DateRangePicker from 'components/DateRangePicker';
import { getSmartLabelClassName } from '../../../../utils/labelWidthUtils';

export interface TransitManagementFilterOptions {
    originHub: string;
    destinationHub: string;
    routeStatus: string;
    updateTime: [string | null, string | null] | null;
}

interface TransitManagementFilterProps {
    filters: TransitManagementFilterOptions;
    setFilters: (filters: TransitManagementFilterOptions) => void;
    onFilter: () => void;
    onResetFilters: () => void;
    onAddRoute?: () => void;
    hubs: HubType[];
    hubsLoading: boolean;
}

const TransitManagementFilter: React.FC<TransitManagementFilterProps> = ({
    filters,
    setFilters,
    onFilter,
    onResetFilters,
    onAddRoute,
    hubs,
    hubsLoading
}) => {
    // 始发地HUB选项 - 从warehouse表读取site_type=1的数据
    const originHubOptions = [
        ...hubs.map(hub => ({
            label: hub.sortingCode!!,
            value: hub.id
        }))
    ];

    // 目的地HUB选项 - 从warehouse表读取site_type=1的数据
    const destinationHubOptions = [
        ...hubs.map(hub => ({
            label: hub.sortingCode!!,
            value: hub.id
        }))
    ];

    // 路线状态选项
    const routeStatusOptions = [
        { label: 'Valid', value: '1' },
        { label: 'Invalid', value: '0' }
    ];

    const handleOriginHubChange = (value: string) => {
        setFilters({ ...filters, originHub: value });
    };

    const handleDestinationHubChange = (value: string) => {
        setFilters({ ...filters, destinationHub: value });
    };

    const handleRouteStatusChange = (value: string) => {
        setFilters({ ...filters, routeStatus: value });
    };

    const handleUpdateTimeChange = (value: [string | null, string | null] | null) => {
        setFilters({ ...filters, updateTime: value });
    };

    const labelOriginHub = 'Origin Hub';
    const labelDestinationHub = 'Destination Hub';
    const labelRouteStatus = 'Route Status';
    const labelUpdateTime = 'Update Time';

    const col1Labels = [labelOriginHub, labelUpdateTime];
    const col2Labels = [labelDestinationHub];
    const col3Labels = [labelRouteStatus];

    return (
        <div className="mb-2 pl-0 py-2">
            {/* 使用 Grid 布局确保列对齐 */}
            <div className="grid grid-cols-3 gap-x-10 gap-y-4 items-start">
                {/* 始发地HUB筛选 */}
                <div className="min-w-0">
                    <SingleSelect
                        label={labelOriginHub}
                        value={filters.originHub}
                        onChange={handleOriginHubChange}
                        options={originHubOptions}
                        spanClassName={getSmartLabelClassName(col1Labels)}
                    />
                </div>

                {/* 目的地HUB筛选 */}
                <div className="min-w-0">
                    <SingleSelect
                        label={labelDestinationHub}
                        value={filters.destinationHub}
                        onChange={handleDestinationHubChange}
                        options={destinationHubOptions}
                        spanClassName={getSmartLabelClassName(col2Labels)}
                    />
                </div>

                {/* 路线状态筛选 */}
                <div className="min-w-0">
                    <SingleSelect
                        label={labelRouteStatus}
                        value={filters.routeStatus}
                        onChange={handleRouteStatusChange}
                        options={routeStatusOptions}
                        spanClassName={getSmartLabelClassName(col3Labels)}
                    />
                </div>
                {/* 第二行：更新时间筛选 */}
                <div className="min-w-0">
                    <DateRangePicker
                        label={labelUpdateTime}
                        value={filters.updateTime}
                        onChange={handleUpdateTimeChange}
                        spanClassName={getSmartLabelClassName(col1Labels)}
                    />
                </div>
                <div className="min-w-0"></div>
                <div className="min-w-0"></div>
            </div>

            {/* 操作按钮 */}
            <div className="mb-1 flex justify-between items-center pl-0">
                <div className="flex gap-4">
                    {onAddRoute && (
                        <Button
                            type="primary"
                            onClick={onAddRoute}
                            className="w-auto min-w-24"
                        >
                            <span className="font-bold">Add</span>
                        </Button>
                    )}
                </div>
                <div className="flex gap-4">
                    <Button
                        type="primary"
                        onClick={onFilter}
                        className="w-auto min-w-24"
                    >
                        <span className="font-bold">Filter</span>
                    </Button>
                    <Button
                        type="default"
                        onClick={onResetFilters}
                        className="w-auto min-w-24"
                    >
                        <span className="font-bold">Reset</span>
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default TransitManagementFilter;
